<script>
import Notification from '../../reUse/Notification.vue';
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Notification,
    Multiselect
  },
  emits: ['backToAdmin'],
  data() {
    return {
      uporabniki: [],
      izbranUserId: '',
      meniji: [],
      meniUporabnika: [],
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  mounted() {
    this.ReadUsers();
    this.ReadMenus();
  },
  methods: {
    ReadMenus() {
      axios.get('./api/nastavitve/meni/izpis').then((response) => {
        this.meniji = response.data.meniji;
      }).catch((error) => {
        alert(error.response.data.napaka);
      });
    },
    ReadUsers() {
      axios.get('./api/uporabniki/izpis/').then((response) => {
        this.uporabniki = response.data.uporabniki;
        if (this.uporabniki.length > 0) {
          this.izbranUserId = this.uporabniki[0];
          setTimeout(() => {
            this.ReadUserMenu();
          }, 500);
        }
      }).catch((error) => {
        alert(error.response.data.napaka);
      })
    },
    ReadUserMenu() {
      var podatki = new URLSearchParams();
      podatki.append('uporabnik', this.izbranUserId.id);
      axios.post('./api/nastavitve/meni/povezava/beri/', podatki, {withCredentials: true}).then((response) => {
        this.meniUporabnika = response.data.meniji.map(meni => meni.id);
      }).catch((error) => {
        alert(error.response.data.napaka);
      });
    },
    AddUserMenu() {
      var podatki = new URLSearchParams();
      podatki.append('meni', JSON.stringify(this.meniUporabnika));
      podatki.append('uporabnik', this.izbranUserId.id);
      axios.post('./api/nastavitve/meni/povezava/vnos/', podatki, {withCredentials: true}).then((response) => {
        this.text = (response.data.sporocilo);
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((error) => {
        this.text = (response.data.sporocilo);
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    izpisUporabnika ({ime, priimek, email}) {
      return `${ime} ${priimek}[${email}]`
    }
  }
}
</script>
<template>
  <!-- <button class="p-2 btn-back" @click.prevent="$emit('backToAdmin')"><i class="fas fa-arrow-up fa-2x"></i></button> -->
  <h5 class="d-flex justify-content-center text-white">Povezava menija</h5>
  <div class="container p-2">
    <div class="d-flex justify-content-center">
    <div class="permissions-card">
      <div class="permissions-header">
        <div>
          <h3>Meniji uporabnika</h3>
          <div class="label-date col-6 p-2">Uporabnik</div>
          <multiselect v-model="izbranUserId"
                       :options="uporabniki"
                       :custom-label="izpisUporabnika"
                       track-by="id"
                       @select="ReadUserMenu()"
                       placeholder="Izberi / najdi uporabnika"
          >
            <template #noResult>
              Uporabnik ne obstaja
            </template>

          </multiselect>
        </div>
          <p>Izberite menije, do katerih ima uporabnik dostop.</p>
      </div>

      <div class="permissions-list">
        <label
            v-for="meni in meniji"
            :key="meni.id"
            class="permission-row"
        >
          <div class="permission-info">
        <span class="permission-name">
          {{ meni.naziv }}
        </span>
          </div>

          <div class="switcher">
            <input
                type="checkbox"
                :value="meni.id"
                v-model="meniUporabnika"
            >
            <span class="drsnik"></span>
          </div>
        </label>
      </div>
      <div class='col-12'>
        <div class="container p-2">
          <button @click.prevent="AddUserMenu()" class="btn btn-primary rounded-pill btn-add col-12">Posodobi zapis</button>
        </div>
      </div>
    </div>
    </div>
  </div>
  <!-- ODMIK OD ROBA -->
  <div class="w-100 p-4"></div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>
<style>
.permissions-card {
  width: 100%;
  max-width: 700px;

  background: #19232c;
  border: 1px solid #293641;
  border-radius: 14px;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);

  overflow: hidden;
}


/* Header */

.permissions-header {
  padding: 20px 24px;

  background: #18222b;
  border-bottom: 1px solid #293641;
}

.permissions-header h3 {
  margin: 0;

  font-size: 17px;
  font-weight: 600;
  color: #f1f5f9;
}

.permissions-header p {
  margin: 5px 0 0;

  font-size: 13px;
  line-height: 1.4;
  color: #8b9aa8;
}


/* Lista */

.permissions-list {
  padding: 8px 0;
}


/* Posamezna vrstica */

.permission-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 58px;
  padding: 10px 24px;

  cursor: pointer;

  transition:
      background-color 0.15s ease,
      border-color 0.15s ease;
}

.permission-row:hover {
  background-color: #202c36;
}

.permission-row:active {
  background-color: #24313c;
}


/* Ime menija */

.permission-info {
  display: flex;
  align-items: center;

  min-width: 0;
}

.permission-name {
  font-size: 14px;
  font-weight: 500;
  color: #d8e0e7;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  transition: color 0.15s ease;
}

.permission-row:hover .permission-name {
  color: #ffffff;
}


/* Switch */

.switcher {
  position: relative;

  width: 44px;
  height: 24px;

  flex: 0 0 auto;
}

.switcher input {
  position: absolute;

  width: 0;
  height: 0;

  opacity: 0;
}


/* Slider */

.drsnik {
  position: absolute;
  inset: 0;

  background-color: #35434e;

  border: 1px solid #465561;
  border-radius: 999px;

  cursor: pointer;

  transition:
      background-color 0.2s ease,
      border-color 0.2s ease;
}

.drsnik::before {
  content: "";

  position: absolute;

  width: 18px;
  height: 18px;

  left: 2px;
  top: 2px;

  background-color: #aebbc6;

  border-radius: 50%;

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);

  transition:
      transform 0.2s ease,
      background-color 0.2s ease;
}


/* ON */

.switcher input:checked + .drsnik {
  background-color: #2563eb;
  border-color: #3b82f6;
}

.switcher input:checked + .drsnik::before {
  background-color: #ffffff;
  transform: translateX(20px);
}


/* Focus */

.switcher input:focus-visible + .drsnik {
  outline: 3px solid rgba(59, 130, 246, 0.25);
  outline-offset: 2px;
}


/* Disabled */

.switcher input:disabled + .drsnik {
  opacity: 0.4;
  cursor: not-allowed;
}

.permission-row:has(input:disabled) {
  cursor: not-allowed;
}


/* Mobile */

@media (max-width: 576px) {
  .permissions-card {
    border-radius: 10px;
  }

  .permissions-header {
    padding: 16px;
  }

  .permission-row {
    padding: 10px 16px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>